<template>
    <main class="p-6">
      <h1>Seed Detail (temporary)</h1>
      <p>Seed ID: <strong>{{ id }}</strong></p>
      <ul>
        <li><router-link to="/watch">Back to Watch Dashboard</router-link></li>
      </ul>
    </main>
  </template>
  
  <script>
  export default {
    name: "SeedDetail",
    props: {
      id: {
        type: String,
        required: true,
      },
    },
  };
  </script>
  